import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { useCallback, useMemo } from 'react';
import { thunkGoToGameGuidePage } from '../../redux/actions/gameGuideActions';
import { selectMyNumJacks } from '../../redux/reducers/selfDataReducer';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { getShortRenderedValueStr } from '../../utils/numberPrecisionUtils';
import { ActionCostIndicator } from './actionCostIndicator';
export const MyBombAmmoDisplay = ({ color }) => {
    const dispatch = useAppDispatch();
    const myNumJacks = useAppSelector(selectMyNumJacks);
    const myNumAmmo = useAppSelector((state) => state.selfData.numAmmo);
    const numJacksStr = getShortRenderedValueStr(myNumJacks || 0);
    const numAmmoStr = getShortRenderedValueStr(myNumAmmo || 0);
    const onClick = useCallback(() => {
        dispatch(thunkGoToGameGuidePage('bomb-ammo-display'));
    }, [dispatch]);
    const containerCss = useMemo(() => css(css `
          display: flex;
          flex-flow: row wrap;
          gap: 0 20px;
          padding: 0 10px;
          cursor: pointer;
        `, color
        ? css `
              color: ${color};
            `
        : undefined), [color]);
    return (_jsx(Typography, { css: containerCss, component: 'div', variant: 'subtitle2', "data-testid": 'my-ammo', onClick: onClick, children: myNumAmmo ? (_jsxs("div", { "aria-label": `Your Ammo: ${numAmmoStr}`, "aria-hidden": true, children: [_jsx(ActionCostIndicator, {}), " ", numAmmoStr, " Ammo"] })) : (_jsxs("div", { "aria-label": `Your Jacks: ${numJacksStr}`, "aria-hidden": true, children: [_jsx(ActionCostIndicator, {}), " ", numJacksStr, " Jack", myNumJacks !== 0 ? 's' : ''] })) }));
};
